import { useCartContext } from "app/providers/CartProvider";
import { concatClassnames } from "shared/utils/concatClassnames";
import StandardProduct from "widgets/checkout/standard-product";

const StandardProductList = () => {
  const cartContext = useCartContext();
  const { standardProducts } = cartContext.getCart();

  const setStandardProductAmount = (id: number, amount: number) => {
    cartContext.changeCartStandardProductAmount(id, amount);
  };

  return (
    <div>
      {standardProducts ? (
        standardProducts.map((standardProduct, id) => {
          return (
            <StandardProduct
              standardProduct={standardProduct}
              index={id}
              key={`panel-${standardProduct.id}-${id}`}
              setStandardProductAmount={(amount) =>
                setStandardProductAmount(id, amount)
              }
              className={concatClassnames(
                id !== standardProducts.length - 1 && "gg-border-b",
                id !== 0 && "gg-pt-9",
                id !== standardProducts.length - 1 ? "lg:gg-pb-9" : "lg:gg-pb-2"
              )}
            />
          );
        })
      ) : (
        <></>
      )}
    </div>
  );
};
export default StandardProductList;
